/**
 * LinkButton Component
 */

import { linkWithCurrentQueryString } from '../../../../utils/router';

import { Link, LocationDescriptor } from 'found';
import * as React from 'react';

import Button, { ButtonProps } from '../Button';

interface IOwnProps extends ButtonProps {
  activeClassName?: string;
  external?: boolean;
  includeQsParams?: boolean;
  to: LocationDescriptor;
}

export type LinkButtonProps = IOwnProps;

export default function LinkButton({
  activeClassName,
  includeQsParams = true,
  external,
  to,
  wrapperComponent,
  ...restProps
}: IOwnProps) {
  const linkProps: Partial<ButtonProps> = {
    ...external ? {
      hyperLinkProps: {
        href: to as string,
        target: '_blank',
      },
      wrapperComponent: 'a',
    } : {
      routerLinkProps: {
        // if `to` is not a string we take for granted that we want to override
        // the current behavior of persisting query string parameters.
        to: (typeof to === 'string' && includeQsParams) ? linkWithCurrentQueryString(to) : to,
        activeClassName,
      },
      wrapperComponent: wrapperComponent || Link,
    },
  };

  return (
    <Button {...linkProps} {...restProps} />
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/buttons/LinkButton/index.tsx